import { useAppDispatch } from "../../store/hooks/dispatch.hook";
import { Action } from "../models/Action";
import { SUBMIT_ACTIONS } from "../constants/submitActions";


function useSubmitAction(deleteRedirect?: () => void) {
    const dispatch = useAppDispatch();

    return (
        submitAction: SUBMIT_ACTIONS, 
        saveHandler?: () => Action, 
        deleteHandler?: () => Action,
        uploadImegesHandler?: () => Action
    ) => {
        switch(submitAction) {
            case SUBMIT_ACTIONS.SAVE :
                if(saveHandler) {
                    dispatch(saveHandler());
                    if(uploadImegesHandler) {
                        dispatch(uploadImegesHandler());
                    }
                }
                break;
            case SUBMIT_ACTIONS.DELETE :
                if(deleteHandler) {
                    dispatch(deleteHandler());
                    if(deleteRedirect) {
                        deleteRedirect();
                    }
                }
                break;
        }
    }
}

export default useSubmitAction